import { render, staticRenderFns } from "./mySwitch.vue?vue&type=template&id=4e8c3efe&scoped=true"
import script from "./mySwitch.vue?vue&type=script&lang=js"
export * from "./mySwitch.vue?vue&type=script&lang=js"
import style0 from "./mySwitch.vue?vue&type=style&index=0&id=4e8c3efe&prod&scoped=true&lang=scss"
import style1 from "./mySwitch.vue?vue&type=style&index=1&id=4e8c3efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c3efe",
  null
  
)

export default component.exports